import React from "react";

const DetailModal = ({ modalText, isDetailsModalOpen, modalHeader }) => {
  return (
      <div
        className="modal d-block modal-background"
        id="detailModal"
        tabIndex="-1"
        aria-labelledby="detailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content border-none">
            <div className="modal-header">
                <h4 className="modal-title" id="myModalLabel">Details</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => isDetailsModalOpen(false)}>
                  <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
              <p>{modalText} </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default DetailModal;
